var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.frontItemsList.length > 0)?_c('v-btn',{attrs:{"color":"success"},on:{"click":_vm.saveQuotation}},[_c('v-icon',[_vm._v("mdi-content-save")]),_vm._v(" Guardar cotización ")],1):_vm._e(),_c('img',{staticClass:"hidden",attrs:{"id":"test","src":_vm.img,"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }